import { notification } from "antd";

export const showNotification = (msg: string) =>
  notification.warning({
    message: msg,
  });
